module.exports = __webpack_public_path__ + "img/raid.872ae0c9.png";